import type React from 'react';
import type { MessageDescriptor } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Card } from 'ui-components/components/card';
import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { noop } from 'ui-components/default-props/noop';

import { messages } from '../automation-playbooks/messages';
import style from './playbook-card.module.less';

import ResidentialScene from './glyphs/residential-scene.svg';
import Scale from './glyphs/scale.svg';
import Shield from './glyphs/shield.svg';
import StoreFront from './glyphs/store-front.svg';
import Tag from './glyphs/tag.svg';
import Van from './glyphs/van.svg';
import LocationPin from './glyphs/location-pin.svg';
import Warehouse from './glyphs/warehouse.svg';

const glyphMap = {
  scale: Scale,
  shield: Shield,
  tag: Tag,
  van: Van,
  locationPin: LocationPin,
  storeFront: StoreFront,
  residentialScene: ResidentialScene,
  warehouse: Warehouse,
};

type PlaybookCardProps = {
  title: MessageDescriptor;
  titleValues?: Record<string, string>;
  description: MessageDescriptor;
  onClick: () => void;
  glyph?: keyof typeof glyphMap;
};

export const PlaybookCard: React.FC<PlaybookCardProps> = ({ title, titleValues, description, onClick = noop, glyph }) => {
  const glyphSrc = glyph ? glyphMap[glyph] : Scale;

  return (
    <Card className={style['playbook-card']}>
      <div className={style.header}>
        <div className={style.glyph}>
          <img alt='' src={glyphSrc} />
        </div>
      </div>
      <FlexColumn className={style.content} gap={Gap.Space16}>
        <Text className={style.title} formattedMessageValues={titleValues} textType={TextType.H4} value={title} />
        <Text textType={TextType.Paragraph} value={description} />
        <Button className={style.action} onClick={onClick} theme={THEME_CONSTANTS.secondary}>
          <Text textType={TextType.Caption} value={messages.previewTemplate} />
        </Button>
      </FlexColumn>
    </Card>
  );
};
